import { render } from "./FallbackTile.vue?vue&type=template&id=01df6ce2&scoped=true&ts=true"
import script from "./FallbackTile.vue?vue&type=script&lang=ts"
export * from "./FallbackTile.vue?vue&type=script&lang=ts"

import "./FallbackTile.vue?vue&type=style&index=0&id=01df6ce2&lang=less&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01df6ce2"]])

export default __exports__